<template>
  <card>
    <h5
      slot="header"
      class="title">Edit Profile</h5>
    <div class="row">
      <div class="col-md-4">
        <label>Logo</label>
        <el-upload
          :action="actionUrl"
          :show-file-list="false"
          :headers="{ Authorization: 'Bearer ' + token }"
          :data="{ type: 'avatar' }"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          name="image"
        >
          <el-avatar
            v-if="admin.logo_url"
            :size="99"
            :src="admin.logo_url"
            shape="square"
            fit="fill"/>

          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
      </div>
      <div class="col-md-8 row">
        <div class="col-md-12">
          <base-input
            v-model="admin.business_name"
            label="Business name"
            placeholder="Business name"
          />
        </div>
        <div class="col-md-12">
          <base-input
            v-model="admin.contact_name"
            label="Contact Name"
            placeholder="Admin Houston"/>
        </div>
        <div class="col-md-12">
          <base-input
            v-model="admin.contact_email"
            label="Contact Email"
            type="email"
            placeholder="test@email.com"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.website"
          label="Website URL"
          placeholder="Website URL (Optional)"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.facebook"
          label="Facebook"
          placeholder="Facebook (Optional)"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.twitter"
          label="Twitter"
          placeholder="Twitter (Optional)"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.instagram"
          label="Instagram"
          placeholder="Instagram (Optional)"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.youtube"
          label="Youtube"
          placeholder="Youtube (Optional)"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input
          v-model="admin.address"
          label="Address"
          placeholder="Home Address"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 pr-md-1">
        <base-input
          v-model="admin.city"
          label="City"
          placeholder="City"/>
      </div>
      <div class="col-md-4 px-md-1">
        <base-input
          v-model="admin.country"
          label="Country"
          placeholder="Country"/>
      </div>
      <div class="col-md-4 pl-md-1">
        <base-input
          v-model="admin.zipcode"
          label="Postal Code"
          placeholder="ZIP Code"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-input>
          <label>About</label>
          <vue-editor
            v-model="admin.description"
            :editor-options="editorOptions"
            :editor-toolbar="editorToolbar"
            :required="true"
            use-custom-image-handler
            @image-added="handleImageAdded"
          />
        </base-input>

      </div>
    </div>
    <base-button
      slot="footer"
      type="primary"
      fill
      @click="editProfile">Save</base-button>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </card>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    model: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    admin: {},
    snack: false,
    snackColor: '',
    snackText: '',
    editorOptions: {
      modules: {
        imageResize: {}
      }
    },
    editorToolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' }
      ],
      ['blockquote', 'code-block'],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [({ indent: '-1' }, { indent: '+1' })],
      [{ color: [] }, { background: [] }],
      ['link', 'image'],
      ['clean']
    ]
  }),
  mounted () {
    this.admin = this.model
  },
  computed: {
    ...mapState(['token']),
    actionUrl: function () {
      return process.env.VUE_APP_API_BASE_URL + '/images/'
    }
  },
  methods: {
    editProfile: function () {
      this.$store.state.spinning = true
      this.$http.put('/admin', this.admin)
        .then((response) => {
          var user = JSON.stringify(response.data)
          localStorage.setItem('user', user)
          this.$store.state.user = response.data
          this.saveInline()
          this.$store.state.spinning = false
          this.admin = response.data.city_admin.city
        }
        )
        .catch(error => {
          if (error && error.response && error.response.status == '422') {
            this.showError(JSON.stringify(error.response.data.errors))
          }
          this.$store.state.spinning = false
          console.log(error)
          this.cancelInline
        })
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Profile updated'
    },
    handleAvatarSuccess (res) {
      console.log('res' + JSON.stringify(res))
      this.admin.logo_url = res.path
    },
    beforeAvatarUpload (file) {
      var mimes = ['image/png', 'image/jpeg', 'image/gif', 'image/jpg']
      const isValid = mimes.includes(file.type)
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isValid) {
        this.$message.error(
          '头像必须是以下类型的图片 JPG, JPEG, GIF or GIF format!'
        )
      }
      if (!isLt50M) {
        this.$message.error('头像图片最大不超过50MB!')
      }
      return isValid && isLt50M
    },
    // wysiwyg related
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)

      var formData = new FormData()
      formData.append('image', file)
      formData.append('type', 'topic')
      this.$http({
        url: '/images',
        method: 'POST',
        data: formData
      }).then(response => {
        let url = response.data.path // Get url from response
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
      })
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 99px;
  height: 99px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px !important;
  height: 178px;
  display: block;
}
</style>
